import { themes } from "components/styles/Theme"

const GlobalStyles = () => {
  return (
    <>
      <style jsx global>{`
        @font-face {
          font-family: "neuzeit-grotesk";
          font-weight: normal;
          font-display: swap;
          src:
            local("neuzeit-grotesk-regular"),
            url(data:application/font-woff2;charset=utf-8;base64,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)
              format("woff2"),
            url("/fonts/Neuzeit-Grotesk-Regular.woff2") format("woff2"),
            url("/fonts/Neuzeit-Grotesk-Regular.woff") format("woff"),
            url("/fonts/Neuzeit-Grotesk-Regular.ttf") format("truetype");
        }
        @font-face {
          font-family: "neuzeit-grotesk";
          font-weight: bold;
          font-display: swap;
          src:
            local("neuzeit-grotesk-bold"),
            url(data:application/font-woff2;charset=utf-8;base64,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)
              format("woff2"),
            url("/fonts/Neuzeit-Grotesk-Bold.woff2") format("woff2"),
            url("/fonts/Neuzeit-Grotesk-Bold.woff") format("woff"),
            url("/fonts/Neuzeit-Grotesk-Bold.ttf") format("truetype");
        }

        .sentry-error-embed-wrapper {
          z-index: 999999999 !important;
        }

        :root {
          --gradient: linear-gradient(160deg, var(--primary) 0%, var(--secondary) 100%);
          --safe-area-inset-bottom: env(safe-area-inset-top);
          --danger: #c4173c;
          --warning: #ff481f;
          --white: #fff;
          --lighter-gray: #f2f1f1;
          --light: #eee;
          --lightDarken: rgba(34, 34, 34, 0.075);
          --dark: #222;
          --black: #000;
          --navColor: var(--black);
          --navBG: #fff;
          --navOverlay: rgba(255, 255, 255, 0.7);
          --boxShadow: 0 0 5px rgba(0, 0, 0, 0.2);
          --boxShadowWhite: 0 0 5px rgba(255, 255, 255, 0.2);
          --lightTransparent: rgba(224, 224, 224, 0);
          --whiteTransparent: rgba(255, 255, 255, 0);
          --shopSpace: 0.9rem;

          --primary: ${themes.green?.primary};
          --secondary: ${themes.green?.secondary};
          --gradientText: ${themes.green?.gradientText};

          // The bs-* variables are only used here. We could remove them
          --bs-font-sans-serif:
            "neuzeit-grotesk", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans",
            "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
          --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
          --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
          --bs-body-font-family: var(--bs-font-sans-serif);
          --bs-body-font-size: 12px !important;
          --bs-body-font-weight: 400 !important;
          --bs-body-line-height: 1.5;
          --bs-body-color: #3c3c3c;
          --bs-body-bg: var(--lighter-gray);
        }

        html {
          overflow-x: hidden;
          margin-right: calc(-1 * (100vw - 100%));
        }

        @media (min-width: 576px) {
          body {
            font-size: 12px !important;
          }
        }

        @media (min-width: 768px) {
          body {
            font-size: 14px !important;
          }
        }

        @media (min-width: 992px) {
          body {
            font-size: 16px !important;
          }
        }

        *,
        *::before,
        *::after {
          box-sizing: border-box;
        }

        @media (prefers-reduced-motion: no-preference) {
          :root {
            scroll-behavior: smooth;
          }
        }

        body {
          margin: 0;
          font-family: var(--bs-body-font-family);
          font-size: var(--bs-body-font-size);
          font-weight: var(--bs-body-font-weight);
          line-height: var(--bs-body-line-height);
          color: var(--bs-body-color);
          text-align: var(--bs-body-text-align);
          background-color: var(--bs-body-bg);
          -webkit-text-size-adjust: 100%;
          -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
          width: 100%;
        }

        hr {
          margin: 1rem 0;
          color: inherit;
          background-color: currentColor;
          border: 0;
          opacity: 0.25;
        }

        hr:not([size]) {
          height: 1px;
        }

        h6,
        h5,
        h4,
        h3,
        h2,
        h1 {
          margin-top: 0;
          margin-bottom: 0.5rem;
          line-height: 1.2;
          font-family: var(--bs-body-font-family);
          font-weight: 700;
          color: var(--secondary);
        }

        h1 {
          font-size: calc(1.375rem + 1.5vw);
        }
        @media (min-width: 1200px) {
          h1 {
            font-size: 2.5rem;
          }
        }

        h2 {
          font-size: calc(1.325rem + 0.9vw);
        }
        @media (min-width: 1200px) {
          h2 {
            font-size: 2rem;
          }
        }

        h3 {
          font-size: calc(1.3rem + 0.6vw);
        }
        @media (min-width: 1200px) {
          h3 {
            font-size: 1.75rem;
          }
        }

        h4 {
          font-size: calc(1.275rem + 0.3vw);
        }
        @media (min-width: 1200px) {
          h4 {
            font-size: 1.5rem;
          }
        }

        h5 {
          font-size: 1.25rem;
        }

        h6 {
          font-size: 1rem;
        }

        p {
          margin-top: 0;
          margin-bottom: 1rem;
        }

        abbr[title],
        abbr[data-bs-original-title] {
          -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
          cursor: help;
          -webkit-text-decoration-skip-ink: none;
          text-decoration-skip-ink: none;
        }

        address {
          margin-bottom: 1rem;
          font-style: normal;
          line-height: inherit;
        }

        ol,
        ul {
          padding-left: 2rem;
        }

        ol,
        ul,
        dl {
          margin-top: 0;
          margin-bottom: 1rem;
        }

        ol ol,
        ul ul,
        ol ul,
        ul ol {
          margin-bottom: 0;
        }

        dt {
          font-weight: 700;
        }

        dd {
          margin-bottom: 0.5rem;
          margin-left: 0;
        }

        blockquote {
          margin: 0 0 1rem;
        }

        b,
        strong {
          font-weight: bolder;
        }

        small {
          font-size: 0.875em;
        }

        mark {
          padding: 0.2em;
          background-color: #fcf8e3;
        }

        sub,
        sup {
          position: relative;
          font-size: 0.75em;
          line-height: 0;
          vertical-align: baseline;
        }

        sub {
          bottom: -0.25em;
        }

        sup {
          top: -0.5em;
        }

        body a {
          color:;
        }

        a {
          color: var(--secondary);
          text-decoration: underline;
        }

        a:hover,
        a:active,
        a:visited,
        a:visited:active {
          color: var(--primary);
        }

        a:not([href]):not([class]),
        a:not([href]):not([class]):hover {
          color: inherit;
          text-decoration: none;
        }

        pre,
        code,
        kbd,
        samp {
          font-family: var(--bs-font-monospace);
          font-size: 1em;
          direction: ltr /* rtl:ignore */;
          unicode-bidi: bidi-override;
        }

        pre {
          display: block;
          margin-top: 0;
          margin-bottom: 1rem;
          overflow: auto;
          font-size: 0.875em;
        }
        pre code {
          font-size: inherit;
          color: inherit;
          word-break: normal;
        }

        code {
          font-size: 0.875em;
          color: #d63384;
          word-wrap: break-word;
        }
        a > code {
          color: inherit;
        }

        kbd {
          padding: 0.2rem 0.4rem;
          font-size: 0.875em;
          color: #fff;
          background-color: #212529;
          border-radius: 0.2rem;
        }
        kbd kbd {
          padding: 0;
          font-size: 1em;
          font-weight: 700;
        }

        figure {
          margin: 0 0 1rem;
        }

        img,
        svg {
          vertical-align: middle;
        }

        table {
          caption-side: bottom;
          border-collapse: collapse;
        }

        caption {
          padding-top: 0.5rem;
          padding-bottom: 0.5rem;
          color: #6c757d;
          text-align: left;
        }

        th {
          text-align: inherit;
          text-align: -webkit-match-parent;
        }

        thead,
        tbody,
        tfoot,
        tr,
        td,
        th {
          border-color: inherit;
          border-style: solid;
          border-width: 0;
        }

        label {
          display: inline-block;
          border-radius: 5px;
        }

        button {
          border-radius: 0;
          touch-action: manipulation;
          color: inherit;
        }

        button:focus:not(:focus-visible) {
          outline: 0;
        }

        input,
        button,
        select,
        optgroup,
        textarea {
          margin: 0;
          font-family: inherit;
          font-size: inherit;
          line-height: inherit;
        }

        button,
        select {
          text-transform: none;
        }

        [role="button"] {
          cursor: pointer;
        }

        select {
          word-wrap: normal;
        }
        select:disabled {
          opacity: 1;
        }

        [list]::-webkit-calendar-picker-indicator {
          display: none;
        }

        button,
        [type="button"],
        [type="reset"],
        [type="submit"] {
          -webkit-appearance: button;
        }
        button:not(:disabled),
        [type="button"]:not(:disabled),
        [type="reset"]:not(:disabled),
        [type="submit"]:not(:disabled) {
          cursor: pointer;
        }

        ::-moz-focus-inner {
          padding: 0;
          border-style: none;
        }

        textarea {
          resize: vertical;
        }

        fieldset {
          min-width: 0;
          padding: 0;
          margin: 0;
          border: 0;
        }

        legend {
          float: left;
          width: 100%;
          padding: 0;
          margin-bottom: 0.5rem;
          font-size: calc(1.275rem + 0.3vw);
          line-height: inherit;
        }
        @media (min-width: 1200px) {
          legend {
            font-size: 1.5rem;
          }
        }
        legend + * {
          clear: left;
        }

        ::-webkit-datetime-edit-fields-wrapper,
        ::-webkit-datetime-edit-text,
        ::-webkit-datetime-edit-minute,
        ::-webkit-datetime-edit-hour-field,
        ::-webkit-datetime-edit-day-field,
        ::-webkit-datetime-edit-month-field,
        ::-webkit-datetime-edit-year-field {
          padding: 0;
        }

        ::-webkit-inner-spin-button {
          height: auto;
        }

        [type="search"] {
          outline-offset: -2px;
          -webkit-appearance: textfield;
        }

        ::-webkit-search-decoration {
          -webkit-appearance: none;
        }

        ::-webkit-color-swatch-wrapper {
          padding: 0;
        }

        ::file-selector-button {
          font: inherit;
        }

        ::-webkit-file-upload-button {
          font: inherit;
          -webkit-appearance: button;
        }

        output {
          display: inline-block;
        }

        iframe {
          border: 0;
        }

        summary {
          display: list-item;
          cursor: pointer;
        }

        progress {
          vertical-align: baseline;
        }

        [hidden] {
          display: none !important;
        }

        .firebase-emulator-warning {
          opacity: 0.5;
          border-width: 0 !important;
          outline: none;
          box-shadow: var(--boxShadow);
          font-weight: bold;
          color: var(--danger) !important;
          display: none;
        }
      `}</style>
    </>
  )
}

export default GlobalStyles
